import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ContentNavigatorTableComponent } from '../../content-navigator/content-navigator-table/content-navigator-table.component';
import {
  BaseContent,
  CTIContentType,
} from '@app/@shared/models/search/cti-search.model';
import { NoAvailableContentMessage } from '@app/@shared/consts/messages';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { MyLibraryService } from '@app/@shared/services/my-library/my-library.service';
import { DialogService } from '@app/@shared/services/dialog/dialog.service';
import { FeatureFlagService } from '@app/@shared/services/featureflag.service';
import { NavigationModules } from '@app/@shared/models/navigation/navigation.models';
import {EntitlementService} from "@shared/services/entitlement/entitlement.service";
import { FilterHelper } from '@app/@shared/utils/filter-helper';
import { CategoryTag } from '@app/@shared/models/search/cti-search.model';
import { environment } from '@env/environment';

@Component({
    selector: 'app-list-all',
    templateUrl: './list-all.component.html',
    styleUrls: ['./list-all.component.scss'],
    standalone: false
})
export class ListAllComponent extends ContentNavigatorTableComponent<BaseContent> implements OnInit {
  @Input() results: Array<BaseContent>;
  @Input() moduleName: NavigationModules;
  @Input() hideMeatballMenu: boolean;
  @Input() props: Partial<{noContentTitle: string, noContentSubTitle: string }> = {};

  @ViewChild('blog', { static: true }) blog: TemplateRef<any>;
  @ViewChild('report', { static: true }) report: TemplateRef<any>;
  @ViewChild('video', { static: true }) video: TemplateRef<any>;
  tplsMap: Map<string, TemplateRef<any>|null> = new Map();

  noContentTitle: string;
  noContentSubTitle: string;
  parseInt = parseInt;

  constructor(
    readonly myLibraryService: MyLibraryService,
    readonly dialogService: DialogService,
    readonly router: Router,
    readonly route : ActivatedRoute,
    readonly ffService: FeatureFlagService,
    readonly entitlementService: EntitlementService,
  ) {
    super(myLibraryService, dialogService, router, route, ffService);
    this.hideMeatballMenu = false;
  }

  ngOnInit(): void {
    this.noContentTitle = this.props.noContentTitle ?? NoAvailableContentMessage.searchMessage.title;
    this.noContentSubTitle = this.props.noContentSubTitle ?? NoAvailableContentMessage.searchMessage.subTitle;
    this.tplsMap.set('blog', this.blog);
    this.tplsMap.set('report', this.report);
    this.tplsMap.set('video', this.video);
  }

  getTemplate(type: string): TemplateRef<any> | null {
    return this.tplsMap.get(type) ?? null;
  }

  onContentClick(content: BaseContent, event) {
    event?.preventDefault();
    if(content.type === CTIContentType.REPORT) {
      const params: Params = FilterHelper.rejectUTMParams();
      this.router.navigate(content.contentUrl, { queryParams: params, queryParamsHandling: 'merge' });
    } else {
      this.handleBlogOrVideoClick(content);
    }
  }

  navigateToAnalysisView(row: { productCode: string}, event, activeTab?: string): void {
    event?.preventDefault();
    event?.stopPropagation();
    const params: Params = FilterHelper.rejectUTMParams();
    const fragment = new URLSearchParams();
    activeTab && fragment.set('activeTab', activeTab);
    this.router.navigate(['analysis-view', row.productCode], {
      fragment: fragment.toString(),
      queryParams: params,
      queryParamsHandling: 'merge'
    });
  }

  createContentTypeUrl(contentTypeRow: BaseContent): string {
    let fragment = '';
    if(contentTypeRow.type === CTIContentType.VIDEO) {
      fragment = `subscription=${encodeURIComponent(contentTypeRow.subscriptionName || contentTypeRow.chanelName)}&name=${encodeURIComponent(this.moduleName)}`;
    }
    return this.router.serializeUrl(
      this.router.createUrlTree([...contentTypeRow.contentUrl], {
        fragment,
      })
    );
  }

  getCategoryTagUrl(tag: CategoryTag): string {
    return `/category-tag/${tag.type}/${tag.key}?name=${encodeURIComponent(tag.name)}`;
  }

  getFilteredCategoryTags(tags: CategoryTag[]): CategoryTag[] {
    if (!tags) return [];
    return tags
      .filter(tag => environment.displayableCategoryTagTypes.includes(tag.type))
      .sort((a, b) => a.name.localeCompare(b.name));
  }

  private handleBlogOrVideoClick(content: BaseContent) {
      if(!content.entitled) {
        const title = `${content.type}: ${content.subscriptionName || content.chanelName}: ${content.name}`;
        this.entitlementService.openRequestAccessConfirmDialog(title);
        return;
      }
      let fragment = '';
      if (content.type === CTIContentType.VIDEO) {
        fragment = `subscription=${encodeURIComponent(content.subscriptionName || content.chanelName)}&name=${content.name}`;
      }
      const params: Params = FilterHelper.rejectUTMParams();
      this.router.navigate(content.contentUrl, { fragment, queryParams: params, queryParamsHandling: 'merge' });
  }
}
